import { render, staticRenderFns } from "./ReviewKeywordsDisplay.vue?vue&type=template&id=1858e4e4&scoped=true"
import script from "./ReviewKeywordsDisplay.vue?vue&type=script&lang=js"
export * from "./ReviewKeywordsDisplay.vue?vue&type=script&lang=js"
import style0 from "./ReviewKeywordsDisplay.vue?vue&type=style&index=0&id=1858e4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858e4e4",
  null
  
)

export default component.exports